<template>
  <div class="editBox">
    <iframe src="mms3D/index.html" frameborder="0" id="mms3D" ref="mms3D"></iframe>
    <div id="titleBox">
      <div class="title">木棉树水电数据治理可视化平台</div>
      <div class="goto">
        <div class="gotoBtn" @click="gotoBtn">返回</div>
      </div>
    </div>
    <component-box @mode1="mode1" @mode2="mode2" @mode3="mode3" @mode4="mode4"/>
  </div>
</template>

<script>
import  ComponentBox  from '../components/content.vue'
export default {
    components:{
      ComponentBox
    },
    methods:{
      // 混流式
      mode1(){
        this.$refs.mms3D.contentWindow.MMAPI.targetTurbine('A')
      },
      // 轴流式
      mode2(){
        this.$refs.mms3D.contentWindow.MMAPI.targetTurbine('B')
      },
      // 机组拆卸
      mode3(){
        this.$refs.mms3D.contentWindow.MMAPI.dismounting(0)
      },
      // 装配组合
      mode4(){
        this.$refs.mms3D.contentWindow.MMAPI.dismounting(1)
      },
      // 返回
      gotoBtn(){
        this.$refs.mms3D.contentWindow.MMAPI.returnView()
      }
    }
}
</script>

<style scoped>
#mms3D{
  width: 100vw;
  height: 100vh;
  position: absolute;

}
.editBox{
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-size: 100% 100%;

}
#titleBox{
  z-index: 10;
  width: 100%;
  height: 110px;
  display: flex;
  padding-left:32px;
  box-sizing: border-box;
}
#titleBox .title{
  flex: 1;
  height: 110px;
  font-size: 47px;
  overflow: hidden;
  line-height: 110px;
  letter-spacing: 4px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PangMenZhengDao;
  text-shadow: 0px 3px 5px rgb(177, 175, 175), 
              0px -3px 5px rgb(177, 175, 175),
              -3px 0px 5px rgb(177, 175, 175),
              3px 0px 5px rgb(177, 175, 175);
}
.goto{
  width: 360px;
  height: 100%;
  display: flex;
  padding-right: 32px;
  align-items: center;
  justify-content: right;
}
.gotoBtn{
  width: 156px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;
  background: url('../assets/img/组11-1.png') no-repeat;
  
}
.gotoBtn:hover{
  background: url('../assets/img/组11-5.png') no-repeat;
  background-size: 100% 100%;
}
</style>